import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import {
  adminClient,
  anonymousClient,
  inferAdditionalFields,
  phoneNumberClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import type { auth } from "@garimpa/auth/auth";

export const authClient = createAuthClient({
  plugins: [
    anonymousClient(),
    adminClient(),
    phoneNumberClient(),
    oauthProviderClient(),
    inferAdditionalFields<typeof auth>(),
  ],
});
